import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, Input } from '@angular/core';
// import { ABBREVIATION_TABLE } from '@vfde-fe/ngx-lib/core';   TODO: Fix it: Module not found: Error: Can't resolve '@vfde-fe/ngx-lib/core
var NotificationComponent = /*@__PURE__*/ (function () {
    /** abbreviationTable */
    // TODO: fix it! public abbreviationTable = ABBREVIATION_TABLE;
    /**
     * TypeScript public modifiers
     */
    function NotificationComponent() {
        this.type = 'error';
        this.badge = true;
        /**
         * Set our default values
         */
        this.localState = { value: '' };
    }
    NotificationComponent.prototype.ngOnInit = function () {
    };
    NotificationComponent.prototype.submitState = function (value) {
    };
    return NotificationComponent;
}());
export { NotificationComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/notification/notification.component.ts
// module id = null
// module chunks = 